import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["value", "onChange", "valueChange", "className", "options", "defaultValue", "horizontalDirection"];
import React from 'react';
import { RadioGroup } from '@headlessui/react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RadioGroupList = function RadioGroupList(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      valueChange = _ref.valueChange,
      className = _ref.className,
      options = _ref.options,
      defaultValue = _ref.defaultValue,
      horizontalDirection = _ref.horizontalDirection,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(RadioGroup, {
    value: value,
    defaultValue: defaultValue,
    onChange: onChange,
    className: clsx({
      'space-y-4': !horizontalDirection,
      'flex flex-row items-center space-x-2': horizontalDirection
    }, className),
    children: options.map(function (option) {
      return /*#__PURE__*/_jsxs(RadioGroup.Option, {
        value: option.value,
        "data-for": "main",
        "data-iscapture": "true",
        onClick: function onClick() {
          onChange === null || onChange === void 0 ? void 0 : onChange(option.value);
          valueChange === null || valueChange === void 0 ? void 0 : valueChange(option.value);
        },
        className: function className(_ref2) {
          var checked = _ref2.checked,
              active = _ref2.active;
          return clsx('relative cursor-pointer rounded-md border-2 px-1 py-4 transition-colors hover:bg-neutral-100', {
            'border-black bg-neutral-100': checked,
            'border-neutral-200': !checked,
            'w-0 flex-1': horizontalDirection
          });
        },
        children: [/*#__PURE__*/_jsxs("p", {
          className: clsx('flex w-full items-center text-center text-base font-semibold text-gray-700', {
            'justify-center': !option.description,
            'px-2 text-left': option.description
          }),
          children: [option.icon && /*#__PURE__*/_jsx("span", {
            className: "mr-2 w-6",
            children: option.icon
          }), /*#__PURE__*/_jsx("span", {
            children: option.label
          })]
        }), option.description && /*#__PURE__*/_jsx("p", {
          className: "px-2 text-sm text-gray-500",
          children: option.description
        }), option.recommended && /*#__PURE__*/_jsx("span", {
          className: "bg-green-success absolute right-0 top-0 rounded-bl-md rounded-tr-md px-2 py-1 text-sm font-bold",
          children: "Recommended"
        })]
      }, option.value);
    })
  });
};